import { apolloClient } from '@/apollo/client'

import { ACCOUNT_STATEMENT_REPORT_QUERY } from '@/graphql/accountStatementReport/accountStatementReport'
import { ACCOUNT_STATEMENT_REPORTS_QUERY } from '@/graphql/accountStatementReport/accountStatementReports'
import { ACCOUNT_STATEMENT_REPORT_CREATE_MUTATION } from '@/graphql/accountStatementReport/accountStatementReportCreate'
import { ACCOUNT_STATEMENT_REPORTS_CANCEL_CREATION_MUTATION } from '@/graphql/accountStatementReport/accountStatementReportsCancelCreation'
import { ACCOUNT_STATEMENT_REPORTS_DELETE_MUTATION } from '@/graphql/accountStatementReport/accountStatementReportsDelete'

export const AccountStatementReportService = {
    get (id) {
        return apolloClient.query({
            query: ACCOUNT_STATEMENT_REPORT_QUERY,
            variables: {
                id: id,
            },
        }).then(response => response.data.accountStatementReport)
    },
    all (variables) {
        return apolloClient.query({
            query: ACCOUNT_STATEMENT_REPORTS_QUERY,
            variables,
        }).then(response => response.data.accountStatementReports)
    },
    create (variables) {
        return apolloClient.mutate({
            mutation: ACCOUNT_STATEMENT_REPORT_CREATE_MUTATION,
            variables,
        }).then(response => response.data.accountStatementReportCreate)
    },
    cancelCreation (variables) {
        return apolloClient.mutate({
            mutation: ACCOUNT_STATEMENT_REPORTS_CANCEL_CREATION_MUTATION,
            variables,
        }).then(response => response.data.accountStatementReportsCancelCreation)
    },
    delete (variables) {
        return apolloClient.mutate({
            mutation: ACCOUNT_STATEMENT_REPORTS_DELETE_MUTATION,
            variables,
        }).then(response => response.data.accountStatementReportsDelete)
    },
}
